import * as z from "zod";
//#region src/__generated__/reporting/reportGenerationModelsController/zod/deleteByModelIdsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const deleteByModelIdsStatus200Schema = z.int();
const deleteByModelIdsResponseSchema = deleteByModelIdsStatus200Schema;
const deleteByModelIdsDataSchema = z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" });
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/dataBufferSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const dataBufferSchema = z.object({});
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/exportAllModelsReportSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const exportAllModelsReportStatus200Schema = z.array(dataBufferSchema);
const exportAllModelsReportResponseSchema = exportAllModelsReportStatus200Schema;
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/projectSearchPatternSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectSearchPatternSchema = z.object({
	pattern: z.enum([
		"CONTAINS",
		"RANGE",
		"EQUALS"
	]).optional().describe("Тип шаблона поиска."),
	value: z.array(z.string()).nullish().describe("Значение критерия поиска.")
}).describe("Критерии поиска, где ключи - названия полей, а значения - объекты ProjectSearchPattern. Возможные поля:\n'title' - название проекта,\n'objectName' - организация,\n'meta' - номер проекта,\n'startDate' - дата начала проекта.\n");
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/projectSearchDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectSearchDtoSchema = z.object({
	page: z.int().describe("Номер страницы для пагинации (нумерация начинается с 1)."),
	searchPatterns: z.object({}).catchall(projectSearchPatternSchema).optional().describe("Критерии поиска, где ключи - названия полей, а значения - объекты ProjectSearchPattern. Возможные поля:\n'title' - название проекта,\n'objectName' - организация,\n'meta' - номер проекта,\n'startDate' - дата начала проекта.\n"),
	size: z.int().describe("Размер страницы (количество элементов на странице)."),
	sortBy: z.enum([
		"ID",
		"TITLE",
		"CREATED_AT",
		"ORGANIZATION",
		"MODIFIED_AT",
		"DELETED_AT",
		"IS_DELETED",
		"AUTHOR_ID",
		"TEMPLATE_ID",
		"DESCRIPTION",
		"START_DATE",
		"END_DATE",
		"LAT",
		"LON",
		"TOTAL_COST",
		"REALISATION_COST",
		"DOCUMENTATION_ID",
		"STAGE",
		"STATUS",
		"TYPE",
		"IS_ARCHIVED",
		"EXTERNAL_ID",
		"MAIN_TITLE"
	]).optional().describe("Поле, по которому будет выполнена сортировка."),
	sortDirection: z.enum(["ASC", "DESC"]).optional().describe("Направление сортировки: ASC (возрастание) или DESC (убывание).")
}).describe("Search object.");
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/exportModelsReportSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const exportModelsReportHeaderXUserIdSchema = z.uuid();
const exportModelsReportQueryIsArchiveSchema = z.boolean().optional();
const exportModelsReportStatus200Schema = z.array(dataBufferSchema);
const exportModelsReportResponseSchema = exportModelsReportStatus200Schema;
const exportModelsReportDataSchema = projectSearchDtoSchema.describe("Search object.");
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/exportReportToExcelSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const exportReportToExcelPathReportIdSchema = z.uuid();
const exportReportToExcelQueryReportExcelEnumsSchema = z.array(z.enum([
	"EXAMINATION",
	"TOTAL_RESULT",
	"RESULT_OF_CHECK"
])).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" });
const exportReportToExcelQueryModelsIdSchema = z.array(z.uuid()).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" });
const exportReportToExcelStatus200Schema = z.array(dataBufferSchema);
const exportReportToExcelResponseSchema = exportReportToExcelStatus200Schema;
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/exportSoftwareModelsBySoftwareNameSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const exportSoftwareModelsBySoftwareNamePathSoftwareNameSchema = z.string();
const exportSoftwareModelsBySoftwareNameStatus200Schema = z.array(dataBufferSchema);
const exportSoftwareModelsBySoftwareNameResponseSchema = exportSoftwareModelsBySoftwareNameStatus200Schema;
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/exportSoftwareModelsReportSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const exportSoftwareModelsReportStatus200Schema = z.array(dataBufferSchema);
const exportSoftwareModelsReportResponseSchema = exportSoftwareModelsReportStatus200Schema;
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/getExcelReportModelsSoftwareMetadataSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getExcelReportModelsSoftwareMetadataStatus200Schema = z.array(dataBufferSchema);
const getExcelReportModelsSoftwareMetadataResponseSchema = getExcelReportModelsSoftwareMetadataStatus200Schema;
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/modelSoftwareInfoDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelSoftwareInfoDtoSchema = z.object({
	createdAt: z.iso.datetime().nullish(),
	fileCreatedAt: z.iso.datetime(),
	id: z.uuid().nullish().describe("Идентификатор записи"),
	metadataJson: z.string().nullish(),
	modelId: z.uuid().nullish(),
	platformIdentifier: z.string(),
	softwareName: z.string(),
	softwareVersion: z.string()
});
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/modelSoftwareInfoViewDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelSoftwareInfoViewDtoSchema = z.object({
	modelName: z.string().nullish(),
	modelSize: z.int().nullish(),
	modelVersion: z.int().nullish(),
	organizationName: z.string().nullish(),
	projectName: z.string().nullish(),
	projectNumber: z.string().nullish(),
	projectStatus: z.boolean().nullish(),
	softwareInfo: z.union([modelSoftwareInfoDtoSchema, z.null()]).optional()
});
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/getSoftwareMetadataByNameSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getSoftwareMetadataByNamePathSoftwareNameSchema = z.string();
const getSoftwareMetadataByNameStatus200Schema = z.array(modelSoftwareInfoViewDtoSchema);
const getSoftwareMetadataByNameResponseSchema = getSoftwareMetadataByNameStatus200Schema;
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/getSoftwareModelByModelIdSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getSoftwareModelByModelIdPathModelIdSchema = z.uuid();
const getSoftwareModelByModelIdStatus200Schema = modelSoftwareInfoDtoSchema;
const getSoftwareModelByModelIdResponseSchema = getSoftwareModelByModelIdStatus200Schema;
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/modelSoftwareMetadataCountDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelSoftwareMetadataCountDtoSchema = z.object({
	modelCount: z.int().nullish(),
	softwareName: z.string().nullish(),
	softwareVersion: z.string().nullish()
});
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/listSoftwareMetadataSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const listSoftwareMetadataStatus200Schema = z.array(modelSoftwareMetadataCountDtoSchema);
const listSoftwareMetadataResponseSchema = listSoftwareMetadataStatus200Schema;
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/listSoftwareMetadataWithContextSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const listSoftwareMetadataWithContextStatus200Schema = z.array(modelSoftwareInfoViewDtoSchema);
const listSoftwareMetadataWithContextResponseSchema = listSoftwareMetadataWithContextStatus200Schema;
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/modelSoftwareInfoRequestSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const modelSoftwareInfoRequestSchema = z.object({
	fileCreatedAt: z.iso.datetime().optional(),
	metadataJson: z.string().optional(),
	modelId: z.uuid(),
	platformIdentifier: z.string().optional(),
	softwareName: z.string().optional(),
	softwareVersion: z.string().optional()
});
//#endregion
//#region src/__generated__/reporting/reportGenerationModelsController/zod/saveSoftwareMetadataSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const saveSoftwareMetadataStatus200Schema = modelSoftwareInfoDtoSchema;
const saveSoftwareMetadataResponseSchema = saveSoftwareMetadataStatus200Schema;
const saveSoftwareMetadataDataSchema = modelSoftwareInfoRequestSchema;
//#endregion
export { exportModelsReportDataSchema as A, deleteByModelIdsDataSchema as B, exportSoftwareModelsBySoftwareNameResponseSchema as C, exportReportToExcelQueryReportExcelEnumsSchema as D, exportReportToExcelQueryModelsIdSchema as E, projectSearchDtoSchema as F, deleteByModelIdsStatus200Schema as H, projectSearchPatternSchema as I, exportAllModelsReportResponseSchema as L, exportModelsReportQueryIsArchiveSchema as M, exportModelsReportResponseSchema as N, exportReportToExcelResponseSchema as O, exportModelsReportStatus200Schema as P, exportAllModelsReportStatus200Schema as R, exportSoftwareModelsBySoftwareNamePathSoftwareNameSchema as S, exportReportToExcelPathReportIdSchema as T, deleteByModelIdsResponseSchema as V, modelSoftwareInfoDtoSchema as _, listSoftwareMetadataWithContextResponseSchema as a, exportSoftwareModelsReportResponseSchema as b, listSoftwareMetadataStatus200Schema as c, getSoftwareModelByModelIdResponseSchema as d, getSoftwareModelByModelIdStatus200Schema as f, modelSoftwareInfoViewDtoSchema as g, getSoftwareMetadataByNameStatus200Schema as h, modelSoftwareInfoRequestSchema as i, exportModelsReportHeaderXUserIdSchema as j, exportReportToExcelStatus200Schema as k, modelSoftwareMetadataCountDtoSchema as l, getSoftwareMetadataByNameResponseSchema as m, saveSoftwareMetadataResponseSchema as n, listSoftwareMetadataWithContextStatus200Schema as o, getSoftwareMetadataByNamePathSoftwareNameSchema as p, saveSoftwareMetadataStatus200Schema as r, listSoftwareMetadataResponseSchema as s, saveSoftwareMetadataDataSchema as t, getSoftwareModelByModelIdPathModelIdSchema as u, getExcelReportModelsSoftwareMetadataResponseSchema as v, exportSoftwareModelsBySoftwareNameStatus200Schema as w, exportSoftwareModelsReportStatus200Schema as x, getExcelReportModelsSoftwareMetadataStatus200Schema as y, dataBufferSchema as z };

//# sourceMappingURL=saveSoftwareMetadataSchema.js.map